export var getAbsoluteUrl = function getAbsoluteUrl(path) {
  if (true) {
    return path.includes("http") ? path : "".concat(location.origin).concat(path);
  }

  return path;
};